module.exports = __webpack_public_path__ + "static/media/1.bfb17618.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_110/images/buy/1.png
// module id = 1090
// module chunks = 0